var map = {
	"./addEvidence.svg": "cc80",
	"./addFolder.svg": "9a8b",
	"./ai.svg": "ad4c",
	"./audio.svg": "5b8d",
	"./copy.svg": "19b6",
	"./cunchu.svg": "e9ef",
	"./email.svg": "cbb7",
	"./environment_ing.svg": "c074",
	"./excel.svg": "6599",
	"./fenxiang.svg": "7823",
	"./folder.svg": "d079",
	"./folder_root.svg": "3415",
	"./jpg.svg": "4cb0",
	"./ketnoy.svg": "7e1d",
	"./other.svg": "5f34",
	"./otherOpus.svg": "6387",
	"./pdf.svg": "f9a1",
	"./picture.svg": "b6c6",
	"./png.svg": "436f",
	"./ppt.svg": "0e4c",
	"./ps.svg": "662e",
	"./rar.svg": "59d4",
	"./video.svg": "8f2b",
	"./video1.svg": "15f0",
	"./word.svg": "bcb8",
	"./zhengjuzongshu.svg": "721c",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";